import React from "react";
import { Link } from "react-router-dom";
import { Facebook } from "lucide-react";
import { BOOKING_URL, CONTACT, FACEBOOK_URL } from "@/lib/site";
import { BookLink } from "@/components/site/BookLink";

const quickLinks = [
  ["Home", "/"], ["Services", "/services"], ["About Us", "/about"],
  ["Peptides", "/peptides"], ["Before & After", "/before-after"],
  ["Reviews", "/reviews"], ["GLP-1 Plans", "/glp1"], ["Financing", "/financing"], ["Contact", "/contact"],
];
const serviceLinks = [
  "Botox Treatment", "Dermal Fillers", "Body Sculpting",
  "Chemical Peels", "IV Hydration", "Peptide Therapy", "Weight Management Plans",
];

export function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[var(--sand)] text-[var(--charcoal)] pt-16 pb-6 border-t border-[var(--line)]">
      <div className="max-w-[1400px] mx-auto px-5 lg:px-10 grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-10">
        <div className="col-span-2 lg:col-span-1">
          <div className="mb-4">
            <img src="/assets/seraphina-logo-header.png" alt="Seraphina Collective" className="h-20 w-auto object-contain" />
          </div>
          <p className="text-sm text-[var(--charcoal-soft)] leading-relaxed max-w-[220px]">
            Medical aesthetics, wellness, and transformation with personalized care.
          </p>
          <a href={FACEBOOK_URL} target="_blank" rel="noopener noreferrer"
             className="inline-flex items-center gap-2 mt-4 text-sm nav-link">
            <Facebook size={16} /> Follow us on Facebook
          </a>
        </div>

        <div>
          <h4 className="eyebrow mb-4">Quick Links</h4>
          <ul className="space-y-2.5">
            {quickLinks.map(([label, to]) => (
              <li key={to}>
                <Link to={to} className="text-sm text-[var(--charcoal-soft)] hover:text-[var(--gold)] transition-colors">{label}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="eyebrow mb-4">Services</h4>
          <ul className="space-y-2.5">
            {serviceLinks.map((s) => (
              <li key={s}>
                <Link to="/services" className="text-sm text-[var(--charcoal-soft)] hover:text-[var(--gold)] transition-colors">{s}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="eyebrow mb-4">Contact</h4>
          <ul className="space-y-2.5 text-sm text-[var(--charcoal-soft)]">
            <li>☎ <a href={CONTACT.phoneHref} className="hover:text-[var(--gold)]">{CONTACT.phone}</a></li>
            <li>Fax: {CONTACT.fax}</li>
            <li>✉ <a href={`mailto:${CONTACT.email}`} className="hover:text-[var(--gold)]">{CONTACT.email}</a></li>
            <li>
              <a href={CONTACT.mapHref} target="_blank" rel="noopener noreferrer" className="hover:text-[var(--gold)]">
                1169 Appomattox Dr<br />Florence, KY 41042
              </a>
            </li>
            <li className="font-medium text-[var(--charcoal)] pt-1">We travel to your home and events too!</li>
          </ul>
        </div>

        <div>
          <h4 className="eyebrow mb-4">Hours</h4>
          <p className="text-sm font-medium mb-2">Available by appointment</p>
          <p className="text-sm text-[var(--charcoal-soft)] mb-5">Please book online or contact us to schedule.</p>
          <BookLink label="Footer" href={BOOKING_URL} className="btn-gold rounded-full px-6 py-3 inline-block">
            Book Appointment
          </BookLink>
        </div>
      </div>

      <div className="max-w-[1400px] mx-auto px-5 lg:px-10 mt-12 pt-5 border-t border-[var(--line)] flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-[var(--charcoal-soft)]">
        <span>© {new Date().getFullYear()} Seraphina Collective. All rights reserved.</span>
        <span className="flex gap-4">
          <Link to="/financing" className="hover:text-[var(--gold)]">Financing</Link>
          <Link to="/contact" className="hover:text-[var(--gold)]">Contact</Link>
        </span>
      </div>
    </footer>
  );
}
